import { AccessRightDto, AccessRightEnum, MemberDto } from '../dtos/member.dto';

export class MemberModel {
    private _member: MemberDto;
    public constructor(member: MemberDto) {
        this._member = member;
    }

    public hasAdminAccess(): boolean {
        let accessRights: AccessRightDto[] = [];
        this._member.roles?.map(role => role.accessRights).forEach(ars => {
            accessRights = accessRights.concat(ars);
        });
        const accessRightNames = accessRights.map(ar => ar.accessRightName);
        return accessRightNames.includes(AccessRightEnum.ADMIN);
    }

    public hasCommonAccess(): boolean {
        let accessRights: AccessRightDto[] = [];
        this._member.roles?.map(role => role.accessRights).forEach(ars => {
            accessRights = accessRights.concat(ars);
        });
        const accessRightNames = accessRights.map(ar => ar.accessRightName);
        return accessRightNames.includes(AccessRightEnum.COMMON);
    }
}
